
<template>
  <div :youMayLike='youMayLike' class="youMayLike">
    <el-row :gutter="20">
      <el-col :span="6" class="MobList" v-for="(item,index) in youMayLike.slice(0,8)" :key="index">
        <div class="youMayLikeCol" @click="Enter(item)">
           <div class="youMayLikeBox">
              <div class="youMayLikeImg">
                  <img v-lazy="$funcs.compressImage(item.defIconUrl)" @error="defImg()" class="lazy-img-fadein"/>
              </div>
              <p class="youMayLikeExhibitName">{{item.productName}}</p>
              <div class="tagList">
                <template v-for="(tagTtem) in item['questionList']">
                  <span class="youMayLikeExhibitLable" v-for="(qItem) in tagTtem['answerList']" :key="qItem.id">{{qItem.aliasName}}</span>
                </template>
              </div>
            </div>
        </div>
       
      </el-col>
      
    </el-row>
    <div class="liveListBtn" @click="goLiveList()">
      <div>{{$t('homes.viewProductLive')}}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    youMayLike: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  data() {
    return {
        tagNameList:[],
        iconUrl:''
    }
  },
  computed: {
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType']),
  },
  created(){
    for(let i in this.youMayLike){
      if(this.youMayLike[i].scope == 1 && this.youMayLike[i].inPool == false){
        this.youMayLike[i].defIconUrl = this.defImage('product1')
      } else {
        if(this.youMayLike[i].iconUrl!=''||this.youMayLike[i].iconUrl!=null||this.youMayLike[i].iconUrl!=undefined){
          this.youMayLike[i].defIconUrl = this.youMayLike[i].iconUrl.split(',')[0]
        }else {
          this.youMayLike[i].defIconUrl = this.defImage('product')
        }
      }
    }
  },
  mounted() {},
  methods: {
    defImg(){
      let img = event.srcElement;
      img.src = this.defImage('product');
      img.onerror = null; //防止闪图
    },
    Enter(item){
      console.log(item)
      if(this.isLogin){
        if(item.scope == 1 && item.inPool == false){
          this.$alert(this.$t('common.productTipsContent'), this.$t('common.productTipsTitle'), {
            confirmButtonText: this.$t('common.ok')
          })
          .then(() => {
            // this.$router.push(`/find-exhibitor/detail/${item.exhibitorId}`)
            this.pageDetail(item, 'actor')
          });
          return
        }else {
          this.pageDetail(item, 'product', true, 'like')
        }
      } else {
        this.pageDetail(item, 'product', true, 'like')
      }
    },
    goLiveList(){
      window.PC.$RangersEvent("homelike_more_click")
      this.$router.push('/find/product')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .tagList{
    height 28px
    width 280px;
    overflow hidden
  }
</style>
